import { useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import { useLocation } from "react-router-dom";
import { useSurveyList } from "./useSurveyList";
import { dateConvert } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Rating } from "@mui/material";
import { faClock } from "@fortawesome/free-regular-svg-icons";

export const useSurveyResponses = () => {

    const { state } = useLocation();
    const [data, setData] = useState([]);
    const [options, setOptions] = useState({
        group_by: [{ label: "Group By Employee", value: true }, { label: "Group By Evaluator", value: false }],
    });
    const { getSurveyInfo, showCreateSurvey } = useSurveyList();
    const [surveyQuestions, setSurveyQuestions] = useState({ list: [], selected: {} });
    const [viewResponse, setViewResponse] = useState({ show: false });
    const [loader, setLoader] = useState(false)
    const [filterValue, setFilterValue] = useState({ isExpand: false, viewfield: false, survey: state?.surveyData?.survey_id, status: "eligible_members" });

    useEffect(() => {
        sessionStorage.removeItem("survey_details");
        callautopopulate("evaluator_users", "survey_details", "users", "day_calendar_groups", "projects", "project_leads").then(async res => {
            const leads = res?.project_leads?.map(item => { return { ...item, group_id: _.findWhere(res?.users, { user_code: item?.user_code })?.group_id } })
            setOptions((prev) => ({
                ...prev, survey_list: _.sortBy(res?.survey_details, "survey_status"),
                users: _.sortBy(_.uniq(res?.evaluator_users, (item) => item.evaluator_user_code), "evaluator_user_name"),
                all_users: _.sortBy(res?.users, "user_display_name"),
                units: _.sortBy(res?.day_calendar_groups, "group_name"),
                projects: _.sortBy(res?.projects, "project_name"),
                leads: _.sortBy(leads, "user_display_name"),
                filtered_leads: _.sortBy(leads, "user_display_name")
            }));
        })
        getSurveyInfoDetails()
        !_.isEmpty(state?.surveyData) && getSurveyInfo(state?.surveyData, "response")
    }, [state?.surveyData])


    const surveyStats = [
        {
            label: "Eligible members",
            icon: "fa-users",
            active: true,
            value: "eligible_members",
        },
        {
            label: "Survey sent",
            icon: "fa-bolt",
            active: false,
            value: "total_participants"
        },
        {
            label: "Scheduled",
            icon: "fa-calendar-days",
            active: false,
            value: "scheduled_sessions"
        },
        {
            label: "Active",
            icon: "fa-clock",
            active: false,
            value: "active_sessions"
        },
        {
            label: "Submitted",
            icon: "fa-circle-check",
            active: false,
            value: "submit_sessions"
        },
        {
            label: "Expired",
            icon: "fa-circle-exclamation",
            active: false,
            value: "expired_sessions"
        },
    ];

    const columns = [
        {
            key: "target_user",
            label: "Subject Name",
            style: { width: "15%", fontWeight: "500" },
            hide: filterValue?.group_by,
            render: (row) => <div className="d-flex align-items-center" title={row?.target_user}>
                <img className="rounded-circle" src={row?.target_image_url} width={25} height={25} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                <span className="px-2 text-dark fw-semibold">{row?.target_user}</span>
                <span
                    onClick={() => {
                        setViewResponse({ show: true, data: _.filter(data?.[0]?.children, (item) => item?.subject_user_code === row?.subject_user_code) })
                    }}><FontAwesomeIcon icon="fa-solid fa-circle-info" />
                </span>
            </div>
        },
        {
            key: "subject_code",
            label: "Subject ID",
            style: { width: "10%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: filterValue?.group_by,
            render: (row) => <span className="fw-semibold text-muted">{row?.subject_code}</span>
        },
        {
            key: "evaluator",
            label: "Evaluator Name",
            style: { width: "15%" },
            hide: !filterValue?.group_by && filterValue?.group_by !== undefined,
            render: (row) => (
                <div className="d-flex align-items-center">
                    <img className="rounded-circle" src={row?.evaluator_image_url} width={25} height={25} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                    <span className="px-2 text-dark fw-semibold">{row?.evaluator}</span>
                    <span onClick={() => setViewResponse({ show: true, data: [row] })}><FontAwesomeIcon icon="fa-solid fa-circle-info" /></span>
                </div>
            )
        },
        {
            key: "evaluator_code",
            label: "Evaluator ID",
            style: { width: "10%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: !filterValue?.group_by && filterValue?.group_by !== undefined,
            render: (row) => <span className="text-muted fw-semibold">{row?.evaluator_code}</span>
        },
        {
            key: "status",
            label: "Status",
            style: { width: "10%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const status = row?.status?.toLowerCase();
                const statusClass =
                    status === 'Active' ? 'text-success border-success' :
                        status === 'pending' ? 'text-warning border-warning' :
                            'text-secondary border-secondary';

                return (
                    <span className="d-flex justify-content-center">
                        <b className={`text-capitalize border px-2 rounded small ${statusClass}`}>
                            {row?.status}
                        </b>
                    </span>
                );
            }
        },
        {
            key: "survey_started",
            label: "Survey Started",
            style: { width: "11%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="fw-semibold text-muted text-truncate">{row?.start_date || "N/A"}</div>
        },
        {
            key: "submitted",
            label: "Submitted",
            style: { width: "11%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="fw-semibold text-muted text-truncate">{row?.submitted_date || "-"}</div>
        },
        {
            key: "minutes",
            label: "Minutes",
            style: { width: "8%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="fw-semibold"><FontAwesomeIcon icon={faClock} style={{ color: "#bab6b6" }} className="fw-bold" /> {row?.time_spent_min}m</div>
        },
        {
            key: "score",
            label: "Score (Total / Avg)",
            style: { width: "10%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => (
                <div className="d-flex align-items-center justify-content-center">
                    <span className="fw-bold text-primary border-end px-2">{row?.total_rating_points}</span>
                    <span className="fw-bold text-success px-2 ">{row?.average_rating}</span>
                    <Rating value={1} readOnly max={1} style={{ fontSize: "14px" }} />
                </div>
            )
        }
    ];

    useEffect(() => {
        if (!_.isEmpty(showCreateSurvey?.data)) {
            let questions = [];
            const sortedCategory = _.sortBy(showCreateSurvey?.data?.survey_question_details, "category_order_number");
            _.filter(sortedCategory, quest => quest?.category_order_number > 0)?.concat(_.filter(sortedCategory, quest => quest?.category_order_number === 0))?.forEach((item) => {
                if (_.isEmpty(_.findWhere(questions, { category: item?.question_category_key }))) {
                    const questList = _.sortBy(_.filter(showCreateSurvey?.data?.survey_question_details, ques => ques?.question_category_key === item?.question_category_key), "question_order_number");
                    const combinedQuest = _.filter(questList, quest => quest?.question_order_number > 0)?.concat(_.filter(questList, quest => quest?.question_order_number === 0))
                    questions.push({
                        category: item?.question_category_key,
                        id: item?.question_category_id,
                        name: item?.question_category_name,
                        questions: _.uniq(combinedQuest, "question_id")
                    })
                }
            })

            let selected = {};
            let category = {};
            showCreateSurvey?.data?.survey_question_details?.forEach(item => {
                selected[item?.question_id] = { question_id: item?.question_id, question_order_number: item?.question_order_number };
                if (!category[item?.question_category_id]) {
                    category[item?.question_category_id] = { question_category_id: item?.question_category_id, category_order_number: item?.category_order_number }
                }
            })
            setSurveyQuestions((prev) => ({ ...prev, list: questions, selected: { questions: selected, category: category } }));
        }

    }, [showCreateSurvey?.data])

    const getSurveyInfoDetails = async (key, value) => {
        try {
            setLoader(true)
            const payload = {
                "survey_id": filterValue?.survey ? filterValue?.survey : 0,
                "user_name": filterValue?.username || "",
                "token": filterValue?.password || "",
                "employee_user_code": _.pluck(filterValue?.users, "evaluator_user_code")?.toString() || "",
                "evaluator_user_code": _.pluck(filterValue?.evaluator, "evaluator_user_code")?.toString() || "",
                "status_key": (key === "status" ? value : filterValue?.status) || "",
                "unit_ids": _.pluck(filterValue?.unit, "group_id")?.toString() || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYINFODETAILS"), payload)
            if (!res?.body?.error_status) {
                const rowData = res?.body?.data
                setOptions((prev) => ({ ...prev, statusCount: rowData?.survey_count[0] }))
                const result = processSurveyData(rowData?.survey_info_list, key === "group" ? undefined : filterValue?.group_by);
                setData(result)
            } else {
                setData([])
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("error", error)
        }
    }
    const processSurveyData = (data, groupBy) => {
        const topLevelGrouped = _.reduce(
            data,
            (acc, item) => {
                let key;
                if (groupBy === true) key = item.subject_user_name;
                else if (groupBy === false) key = item.evaluator_user_name;
                else key = "all";

                if (!acc[key]) acc[key] = [];
                acc[key].push(item);
                return acc;
            },
            {}
        );
        return _.map(topLevelGrouped, (items, title) => {
            const subGrouped = _.groupBy(items, i => `${i.target_employee_id}_${i.evaluator_employee_id}`);
            const processedChildren = _.map(subGrouped, (groupItems) => {
                const first = groupItems[0];
                const ratingValues = [];
                groupItems.forEach(i => {
                    if (i.question_type_name === "rating") {
                        ratingValues.push(Number(i.answer_data || 0));
                    }
                });

                const ratingSum = ratingValues.reduce((a, b) => a + b, 0);
                const avg = ratingValues.length > 0 ? ratingSum / ratingValues.length : 0;
                let totalSeconds = 0;
                const sessions = new Set();
                groupItems.forEach(i => {
                    const sKey = `${i.start_datetime}_${i.end_datetime}`;
                    if (!sessions.has(sKey)) {
                        const diff = (new Date(i.end_datetime) - new Date(i.start_datetime)) / 1000;
                        totalSeconds += diff > 0 ? diff : 0;
                        sessions.add(sKey);
                    }
                });

                return {
                    target_user: first.subject_user_name,
                    evaluator: first.evaluator_user_name,
                    subject_code: first?.target_employee_id,
                    evaluator_code: first?.evaluator_employee_id,
                    evaluator_user_code: first.evaluator_user_code,
                    target_image_url: first?.target_image_url,
                    evaluator_image_url: first.evaluator_image_url,
                    subject_user_code: first.subject_user_code,
                    status: new Date(first.end_datetime) > new Date() ? "Active" : "Completed",
                    start_date: dateConvert(first.start_datetime, "date-time-months"),
                    submitted_date: dateConvert(first.end_datetime, "date-time-months"),
                    category: first.question_category_name,
                    time_spent_min: Math.floor(totalSeconds / 60),
                    total_rating_points: ratingSum,
                    total_rating_questions: ratingValues.length,
                    average_rating: parseFloat(avg.toFixed(2)),
                    target_role_on_project: first?.target_role_on_project,
                    questions_answers: groupItems.map(i => ({
                        question: i.question_title,
                        answer: i.answer_data === null ? "-" : i.answer_data,
                        type: i.question_type_name,
                        category: i.question_category_name,
                    })),
                    total_time_spent_seconds: parseFloat(totalSeconds.toFixed(3)),
                };
            });

            return {
                id: title,
                title: title === "all" ? "" : title,
                children: _.sortBy(processedChildren, "target_user")
            };
        });
    };

    return useMemo(() => ({
        loader, data, state, showCreateSurvey, surveyQuestions, setSurveyQuestions, filterValue, setFilterValue, options, getSurveyInfoDetails, columns, surveyStats, viewResponse, setViewResponse
    }), [loader, data, state, showCreateSurvey, surveyQuestions, setSurveyQuestions, filterValue, setFilterValue, options, getSurveyInfoDetails, columns, surveyStats, viewResponse, setViewResponse])
}


